module.exports = __webpack_public_path__ + "static/say-hello-s-1b137e87ab4fd3c7a327c44239440239.mp4";